import { trackEvent } from 'dibs-tracking';
import { useState, useCallback } from 'react';

const ITEMS_REFETCH_LIMIT = 4;

type PaginationHooks = {
    onClickArrow: (callback?: () => void) => void;
    onCarouselReset: () => void;
    hasFetchedAllImages: boolean;
};

export const usePaginationHooks = (
    loadNext: (count: number, options: { onComplete: () => void }) => void,
    options?: { itemsRefetchLimit?: number; label?: string; action?: string; category?: string }
): PaginationHooks => {
    const {
        category = 'product',
        label = 'pdp carousel',
        action = 'pdp module arrow click',
        itemsRefetchLimit = ITEMS_REFETCH_LIMIT,
    } = options || {};
    const [hasFetchedAllImages, setHasFetchedAllImages] = useState(false);
    const onClickArrow = useCallback(
        (callback: () => void = () => {}) => {
            if (!hasFetchedAllImages) {
                setHasFetchedAllImages(true);
                loadNext(itemsRefetchLimit, { onComplete: callback });
            }
            trackEvent(
                {
                    label,
                    category,
                    isInteractiveEvent: true,
                    action,
                },
                null
            );
        },
        [hasFetchedAllImages, itemsRefetchLimit, loadNext, label, action, category]
    );

    const onCarouselReset = useCallback(() => {
        setHasFetchedAllImages(false);
    }, []);

    return {
        onClickArrow,
        onCarouselReset,
        hasFetchedAllImages,
    };
};
